module.exports = __webpack_public_path__ + "img/7.f0d5a6a7.svg";